"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quantityRangeValidatorErrorKeys = void 0;
const LocalizedRangeValidatorFn_1 = require("./LocalizedRangeValidatorFn");
/**
 * An Array of the Quantity Range Validator Error Keys.
 */
exports.quantityRangeValidatorErrorKeys = LocalizedRangeValidatorFn_1.localizedRangeValidatorErrorKeys;
//# sourceMappingURL=QuantityRangeValidatorFn.js.map